"use client"

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible"
import { MOBILE_APP_FAQ } from "@/lib/mobile-app"

export function MobileAppFaq() {
  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-2">
      {MOBILE_APP_FAQ.map((item, index) => (
        <Collapsible
          key={item.q}
          defaultOpen={index === 0}
          className="rounded-xl border border-border bg-card"
        >
          <CollapsibleTrigger className="cursor-pointer px-4 py-3 text-left text-sm font-medium text-foreground hover:bg-muted/40">
            {item.q}
          </CollapsibleTrigger>
          <CollapsibleContent className="border-t border-border px-4 py-3 text-sm leading-relaxed text-muted-foreground">
            {item.a}
          </CollapsibleContent>
        </Collapsible>
      ))}
    </div>
  )
}
